import { render, staticRenderFns } from "./DeleteCampaign.vue?vue&type=template&id=1bb919a0&"
import script from "./DeleteCampaign.vue?vue&type=script&lang=js&"
export * from "./DeleteCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports